import React, {useEffect} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import OrganizationFilialMapCRUDTable from "../../components/CRUD/Tables/OrganizationFilialMapCRUDTable";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ORGANIZATION_FILIAL_MAP_CREATE_ROUTE } from "../../routes";
import { ORGANIZATION_FILIAL_MAP_EDIT_ROUTE } from "../../routes";
import { ORGANIZATION_FILIAL_MAP_DETAILS_ROUTE } from "../../routes";
import { organizationFilialMapCRUD } from "../../http";
import useReload from "../../hooks/useReload";

const OrganizationFilialMapList = () => {
    const location = useLocation();

    const { push } = useHistory();

    const { reload, reloadValue } = useReload();

    const handleDelete = async (id) => {
        await organizationFilialMapCRUD.delete(id);
        await reload();
    }

    return (
        <DashboardLayout>
            <OrganizationFilialMapCRUDTable
                onClickCreateButton={() => push(ORGANIZATION_FILIAL_MAP_CREATE_ROUTE)}
                onRowClick={(record, rowIndex) => push(ORGANIZATION_FILIAL_MAP_EDIT_ROUTE(record.id), { record })}
                onClickDetailsButton={(id) => push(ORGANIZATION_FILIAL_MAP_DETAILS_ROUTE(id), { id })}
                onClickDeleteButton={(id) => handleDelete(id)}
                reloadValue={reloadValue}
            />
        </DashboardLayout>
    )
};

export default OrganizationFilialMapList;
